import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material';

interface NoContentProps {
  title: string;
  description: string;
  bgColor?: string;
}

const NoContent: React.FC<NoContentProps> = ({ title, description, bgColor }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '60vh',
        py: 8
      }}
    >
      <Box
        sx={{
          textAlign: 'center',
          px: 4,
          py: 2,
          maxWidth: '740px',
          backgroundColor: bgColor ?? theme.palette.background.default
        }}
      >
        <Typography variant="body1" color="textPrimary" fontWeight="bold">
          {title}
        </Typography>

        <Typography variant="body1" color="textSecondary" sx={{ mt: 1 }}>
          {description}
        </Typography>
      </Box>
    </Box>
  );
};

export default NoContent;
